import React, { useEffect, useState } from "react";
import styled from "styled-components";
import assets from "../../../assets/assets";
import { IconController } from "../../Scripts/ImgController";
import Skeleton from "react-loading-skeleton";
const Wrapper = styled.div`
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  height: 50%;
  .border-CK {
    border-bottom: 1px solid #e5e7eb;
  }
  .color-CK {
    color: #374151;
  }
  .color-green {
    color: #22c55e;
  }
  .color.red {
    color: red;
  }
`;
const ListenCard = ({ datas, loaded, type = "music" }) => {
  const [percentageNumber, setPercentageNumber] = useState();
  const [uptrend, setUptrend] = useState(false);
  const [number, setNumber] = useState(false);
  // const begin = props.datas.begin;
  // const end = props.datas.end;
  //    const begin = 13;
  // const end = 100000000;
  // useEffect(() => {
  //    setPercentageNumber(((end - begin) / begin) * 100);

  // }, [datas]);
  // useEffect(() => {
  //    if (percentageNumber >= 1) {
  //       setUptrend(true);
  //        setNumber(true);
  //    }
  //    if (percentageNumber <= 0) {
  //       setUptrend(false);
  //        setNumber(true);
  //    }
  // }, [percentageNumber]);

  return (
    <Wrapper className="w-full">
      <div className="flex flex-col p-6">
        {type === "music" ? (
          <h4 className="pb-2 border-CK color-CK text-sm font-bold">
            Сонсолтын тоо
          </h4>
        ) : (
          <h4 className="pb-2 border-CK color-CK text-sm font-bold">
            Дуулалтын тоо
          </h4>
        )}

        {loaded ? (
          <h5 className="py-3 font-bold text-3xl">{datas?.value}</h5>
        ) : (
          <div className="w-full h-full text-center py-4">
            <Skeleton count={1} height={30} />
          </div>
        )}

        <div className="flex flex-row items-center gap-1">
          {/* {number ? <IconController src={uptrend ? assets.svg.walletTrendingUp : assets.svg.walletTrendingDown} className="w-5 h-5" /> : ""}
               {number ? <span className={`font-semibold text-sm ${uptrend ? "color-green" : 'color-red'}`}>{percentageNumber.toFixed(2)}%</span> : ""} */}
          <h4 className="text-xs font-semibold color-grey">
            Сонгосон хугацаан дах
          </h4>
        </div>
      </div>
    </Wrapper>
  );
};

export default ListenCard;
